import { composeIO } from 'react-compose-io'
import { RegraTransformacaoApiView } from './RegraTransformacaoApi.View'
import { regraTransformacaoApiIO } from './RegraTransformacaoApi.IO'

export const RegraTransformacaoApi = composeIO(RegraTransformacaoApiView, regraTransformacaoApiIO)
